import axios from 'axios';
export const MatterTagsStore = {
  matterTagsList: []
};
export default class MatterTagsService {
  constructor(alerts) {
    this.alerts = alerts;
  }

  /**
   * Retrieves matter tags.
   * Returns cached tags if available, otherwise makes an API call and caches the result.
   *
   * @returns {Promise<Array>} A promise that resolves with the list of matter tags.
   */
  async getMatterTags() {
    if (MatterTagsStore.matterTagsList.length > 0) {
      return MatterTagsStore.matterTagsList;
    }

    // Cache the in-flight request too, not just the resolved list -- two
    // callers arriving before the first response lands would otherwise both
    // see an empty cache and both hit the network.
    if (!this.pendingRequest) {
      this.pendingRequest = axios.get(`/mattertags`).then(response => {
        MatterTagsStore.matterTagsList = response.data.mattertags;
        return MatterTagsStore.matterTagsList;
      }).catch(error => {
        const message = error?.response?.data?.message || error?.message || 'Failed to load matter tags.';
        this.alerts.error(message);
        return [];
      }).finally(() => {
        this.pendingRequest = null;
      });
    }
    return this.pendingRequest;
  }

  /**
   * Resets the cached matter tags.
   */
  reset() {
    MatterTagsStore.matterTagsList = [];
  }
}